import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { feesMasterKeys } from '../feesMasterQueryKeys'
import { getFeeDefinitionVersions } from '../feesMasterEndpoints'

export function useFeeDefinitionVersionsQuery(
  id: MaybeRefOrGetter<string | null>,
  isEnabled: MaybeRefOrGetter<boolean> = true,
) {
  return useQuery({
    queryKey: computed(() => feesMasterKeys.versions(toValue(id) ?? '')),
    queryFn: () => getFeeDefinitionVersions(toValue(id) as string),
    enabled: () => Boolean(toValue(id)) && Boolean(toValue(isEnabled)),
  })
}
